var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuasar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 36,
    viewBox: "0 0 149 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_124",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 149,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.51 0H0.5V35.1025H148.51V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_124)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0281 22.4442V11.1758H68.8934V21.2548C68.8934 23.7517 70.1133 25.1203 72.3418 25.1203C75.4328 25.1203 77.1578 22.4442 77.1578 18.6378V11.1758H81.0228V28.2118H77.1578V25.5947C75.7298 27.4685 73.6488 28.5682 71.2108 28.5682C67.4353 28.5682 65.0259 25.9227 65.0259 22.4442H65.0281Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6968 23.5155C83.6968 20.4239 86.0168 18.5196 90.8028 17.7763L95.0248 17.1226V16.7946C95.0248 15.1286 93.8048 14.2388 91.6948 14.2388C89.4058 14.2388 87.9188 15.3079 87.4428 17.3303L84.2898 15.0696C85.6278 12.2448 88.1838 10.8171 91.8408 10.8171C96.2708 10.8171 98.7398 12.8985 98.7398 16.6438V24.5234C98.7398 25.9795 98.8878 27.2301 99.1258 28.2095H95.2918C95.1428 27.6149 95.0838 26.9612 95.0248 25.9204C93.5688 27.7329 91.7848 28.5659 89.4958 28.5659C86.0478 28.5659 83.6968 26.6048 83.6968 23.5111V23.5155ZM95.0248 20.601V20.2731L91.9918 20.7497C88.8108 21.2548 87.6218 21.9697 87.6218 23.3362C87.6218 24.5846 88.6318 25.3279 90.2668 25.3279C92.6458 25.3279 95.0248 23.7822 95.0248 20.601Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.059 23.6926L104.507 22.0878C104.745 23.9615 106.678 25.3279 108.878 25.3279C110.603 25.3279 111.851 24.5255 111.851 23.4542C111.851 22.0878 109.77 21.7008 107.511 21.0755C104.835 20.3627 101.921 19.322 101.921 15.9922C101.921 12.8701 104.538 10.9089 108.521 10.9089C112.03 10.9089 114.735 12.634 115.537 15.1614L111.941 16.7662C111.823 15.2488 110.454 14.1491 108.432 14.1491C106.976 14.1491 105.786 14.7438 105.786 15.7255C105.786 17.0635 108.045 17.3915 110.395 18.0452C113.012 18.7579 115.747 19.8577 115.747 23.1591C115.747 26.4604 112.982 28.5703 108.88 28.5703C104.778 28.5703 102.072 26.8168 101.062 23.6947L101.059 23.6926Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.529 23.5155C117.529 20.4239 119.849 18.5196 124.635 17.7763L128.857 17.1226V16.7946C128.857 15.1286 127.637 14.2388 125.527 14.2388C123.238 14.2388 121.751 15.3079 121.274 17.3303L118.122 15.0696C119.46 12.2448 122.016 10.8171 125.673 10.8171C130.103 10.8171 132.571 12.8985 132.571 16.6438V24.5234C132.571 25.9795 132.72 27.2301 132.958 28.2095H129.123C128.975 27.6149 128.916 26.9612 128.857 25.9204C127.401 27.7329 125.617 28.5659 123.327 28.5659C119.879 28.5659 117.529 26.6048 117.529 23.5111V23.5155ZM128.857 20.601V20.2731L125.824 20.7497C122.643 21.2548 121.454 21.9697 121.454 23.3362C121.454 24.5846 122.464 25.3279 124.099 25.3279C126.478 25.3279 128.857 23.7822 128.857 20.601Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.243 28.2118H136.378V11.1757H140.243V13.7928C141.374 11.9497 143.068 10.8193 145.001 10.8193C146.546 10.8193 147.915 11.5321 148.51 12.4241L146.785 15.6949C146.339 15.0106 145.447 14.5055 144.347 14.5055C142.176 14.5055 140.243 16.4077 140.243 21.4035V28.2118Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6931 28.1679L64.7197 28.2116L59.8749 24.4511C61.4469 22.5599 62.3476 20.0566 62.3476 17.1815C62.3454 10.7864 57.73 6.23447 51.4814 6.15567V6.15137C51.4531 6.15137 51.4267 6.15137 51.3985 6.15137C51.3699 6.15137 51.3439 6.15137 51.3153 6.15137V6.15567C45.0667 6.23447 40.4512 10.7864 40.4512 17.1815C40.4512 23.5766 44.894 28.1308 51.3153 28.2073V28.2116C51.3439 28.2116 51.3699 28.2116 51.3985 28.2116C51.4267 28.2116 51.4531 28.2116 51.4814 28.2116V28.2073C53.4515 28.1832 55.2377 27.7394 56.7638 26.9501L57.6931 28.1679ZM51.4007 24.4052C47.5484 24.3637 44.7652 21.4624 44.7652 17.1815C44.7652 12.9006 47.5506 9.99927 51.4007 9.95777C55.2529 9.99927 58.0361 12.9006 58.0361 17.1815C58.0361 18.6092 57.3214 20.9376 56.7638 22.0024L49.516 17.4329L54.3214 23.7406C53.4536 24.1603 52.4675 24.3899 51.3985 24.403L51.4007 24.4052Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_38_124",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 35
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3997 0H0.5V34.8997H35.3997V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_38_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0575 17.0098L0.5 8.84448V27.1411C0.5 31.426 3.9736 34.8996 8.2585 34.8996H26.5551L17.1867 17.1354C17.158 17.0809 17.1127 17.0371 17.0575 17.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6413 0H9.34473L18.8405 17.8277C18.8692 17.8818 18.9144 17.9252 18.9693 17.9525L35.4001 26.0551V7.7585C35.3998 3.4736 31.9262 0 27.6413 0Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuasar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/quasar.7ac2fecfa1b9d200e7eb62e573612a13.svg";